import { all, takeLatest, call, put } from 'redux-saga/effects';
import ActionTypes from './types';
import { getBaseMapsSuccess, getBaseMapsFailure } from './actions';
import { getBaseMaps } from 'services/map.service';

function* handleGetBaseMaps(request: any) {
  try {
    const { basemaps } = request.payload;
    const maps: any[] = yield call(getBaseMaps, basemaps);
    if (Array.isArray(maps)) {
      const results = basemaps.map((m: any, inx: number) => {
        return {
          ...m,
          thumbnailUrl: maps[inx].thumbnailUrl
        };
      });
      yield put(getBaseMapsSuccess(results));
    }
  } catch (err) {
    put(getBaseMapsFailure('Unable to get basemaps'));
  }
}

function* watchGetBaseMapsRequest() {
  yield takeLatest(ActionTypes.GET_BASE_MAPS_START, handleGetBaseMaps);
}

function* sagas() {
  yield all([call(watchGetBaseMapsRequest)]);
}
export default sagas;
